import styled from "styled-components";

export const ManagedServicesNav = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: auto;
`;

export const ManagedServicesRow = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: start;
    text-align: start;
    z-index: 1;
`;

export const ManagedServicesTitle = styled.div`
    color: #0071CE;
    font-size: 0.9vw;
    margin-bottom: 3%;
    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }
`;

export const ManagedServicesBody = styled.div`
    color: #565656;
    font-size: 0.9vw;
    font-style: normal;
    font-weight: 400;
    cursor: pointer;
`;